import React, { FC, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ListItemIcon,
  ListItemText,
  ListItem,
  Button,
} from '@material-ui/core';

import MenuBookIcon from '@material-ui/icons/MenuBook';

interface Props {
  // will be used for future prop implementations
}

const manualTexts: string[] = [
  'Vejledning til brug af webportal',
  'Vejledning til brug af mobilbasen',
  'Service menu manual',
  'Bruger manual betalingsautomat ST-609',
];

export const Manuals: FC<Props> = () => {
  const [open, setOpen] = useState(false);

  const handleShortcutOpen = () => {
    // opens the shortcut list
    setOpen(true);
  };

  const handleShortcutClose = () => {
    //closes the shortcut list and clears AnchorE1
    setOpen(false);
  };

  const downloadPDF = () => {
    setOpen(false);
  };

  const fileToDownload = (index: number) => {
    switch (index) {
      case 0:
        return 'Brugermanual_Webportal_06_2023.pdf';
      case 1:
        return 'Brugermanual_Mobilbase_01_2022.pdf';
      case 2:
        return 'Servicemenumanual_version_3_2022.pdf';
      case 3:
        return 'Bruger_manual_ST-609.pdf';
      default:
    }
  };

  return (
    <>
      <ListItem onClick={handleShortcutOpen}>
        <ListItemIcon>
          <MenuBookIcon />
        </ListItemIcon>
        <ListItemText primary={<b> Manualer </b>} />
      </ListItem>

      <Dialog
        open={open}
        onClick={() => handleShortcutClose()}
        aria-labelledby="loading-symbol"
        aria-describedby="loading-des"
      >
        <DialogTitle id="alert-dialog-title">{'Manualer'}</DialogTitle>
        <DialogContent
          style={{
            display: 'flex',
            alignContent: 'center',
            alignSelf: 'center',
            alignItems: 'center',
          }}
        >
          <DialogContentText id="alert-dialog-description">
            {manualTexts.map((str: string, index) => (
              <ListItem key={index} alignItems="flex-start">
                <ListItemText style={{ width: 200 + 'px' }} primary={str} />
                <Button
                  onClick={downloadPDF}
                  color="primary"
                  download={str}
                  href={require(`../Manuals/${fileToDownload(index)}`)}
                >
                  Hent her
                </Button>
              </ListItem>
            ))}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};
